import "./RefurbishmentScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import Refurbishment from "./sections/Refurbishment";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function RefurbishmentScaffoldingPage() {
  return <div>
      <Header />
      <Refurbishment />
      <RelatedServices />
      <Footer />
    </div>;
}